import React from 'react';
import styled from 'styled-components';
import {colors} from '../../../styleVariables';

const Style = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  text-align: left;
  line-height: 1rem;
  font-size: 0.8rem !important;

  > strong {
    color: ${(props) => props.theme};
  }

  span {
    color: ${colors.gray} !important;
  }
`;

const Contact = ({contact, theme}) => {
  return (
    <Style className="mt-3" theme={theme}>
      <strong className="mb-1" style={{color: theme}}>
        Contato
      </strong>
      <span>{contact}</span>
    </Style>
  );
};

export default Contact;
